<template>
  <div class="ccui-app-box-iframe-operate-container">
    <template v-if="labelShow">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
    </template>
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <!-- <div v-if="relationWarningList.length > 0" class="tips">
          <div style="color: red">温馨提示：</div>
          <div v-for="(item, index) in relationWarningList" :key="index">
            {{ item }}
          </div>
        </div> -->
        <el-tabs class="el-tabs__customize" value="1">
          <el-tab-pane
            :label="type == 0 ? '技术评分汇总' : '商务技术评分汇总'"
            name="1"
          >
            <template v-if="subPackageFlag">
              <el-tabs class="customeTab" v-model="active">
                <el-tab-pane
                  v-for="(listItem, listIndex) in listData"
                  :key="listItem.packId"
                  :label="listItem.packName"
                  :name="listIndex + ''"
                >
                  <template
                    v-if="
                      type == 0 &&
                        isCheckedHighAndLow &&
                        active2 == '2' &&
                        status == 1
                    "
                  >
                    <div class="remarkTip fl">
                      备注：红色分值为去掉的最高分或最低分
                    </div>
                  </template>

                  <el-tabs class="summaryTab" v-model="active2">
                    <el-tab-pane label="汇总表" name="1">
                      <el-table :data="listItem.summaryTableData" border>
                        <el-table-column
                          v-for="(item, index) in listItem.summaryColumns"
                          :key="index"
                          :header-align="item.money ? 'center' : ''"
                          :show-overflow-tooltip="true"
                          v-bind="item"
                        >
                          <template
                            v-if="item.labelChild && item.labelChild.length > 0"
                          >
                            <el-table-column
                              v-for="(child, indexch) in item.labelChild"
                              :key="indexch"
                              width="150"
                              align="center"
                              v-bind="child"
                            >
                              <template slot="header">
                                <div
                                  :title="child.label"
                                  class="el-tooltip tooltip-header"
                                  :class="{
                                    'tooltip-header-flow':
                                      child.label.length > 15
                                  }"
                                >
                                  {{ child.label }}
                                </div>
                              </template>
                              <template
                                v-if="
                                  child.labelChild &&
                                    child.labelChild.length > 0
                                "
                              >
                                <el-table-column
                                  v-for="(childs, indexch) in child.labelChild"
                                  :key="indexch"
                                  align="center"
                                  width="180"
                                  :prop="childs.prop"
                                >
                                  <template slot="header">
                                    <div
                                      :title="childs.label"
                                      class="el-tooltip tooltip-header"
                                      :class="{
                                        'tooltip-header-flow':
                                          childs.label.length > 15
                                      }"
                                    >
                                      {{ childs.label }}
                                    </div>
                                  </template>
                                </el-table-column>
                              </template>
                            </el-table-column>
                          </template>
                          <template slot-scope="scope">
                            <span v-if="item.money">{{
                              scope.row[item.prop]
                                ? new BigNumber(scope.row[item.prop]).toFormat(
                                    2
                                  )
                                : scope.row[item.prop]
                            }}</span>
                            <span v-else>{{ scope.row[item.prop] }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="打分表" name="2">
                      <el-table
                        :data="listItem.data"
                        border
                        max-height="460"
                        :span-method="spanMethod"
                      >
                        <el-table-column
                          v-for="(item, index) in listItem.columns"
                          :key="index"
                          :header-align="item.money ? 'center' : ''"
                          :show-overflow-tooltip="true"
                          v-bind="item"
                        >
                          <template
                            v-if="item.labelChild && item.labelChild.length > 0"
                          >
                            <el-table-column
                              v-for="(child, indexch) in item.labelChild"
                              :key="indexch"
                              align="center"
                              v-bind="child"
                            >
                              <template slot="header">
                                <div
                                  :title="child.label"
                                  class="el-tooltip tooltip-header"
                                  :class="{
                                    'tooltip-header-flow':
                                      child.label.length > 15
                                  }"
                                >
                                  {{ child.label }}
                                </div>
                              </template>
                              <template
                                v-if="
                                  child.labelChild &&
                                    child.labelChild.length > 0
                                "
                              >
                                <el-table-column
                                  v-for="(childs, indexch) in child.labelChild"
                                  :key="indexch"
                                  align="center"
                                  width="180"
                                  :prop="childs.prop"
                                >
                                  <template slot="header">
                                    <div
                                      :title="childs.label"
                                      class="el-tooltip tooltip-header"
                                      :class="{
                                        'tooltip-header-flow':
                                          childs.label.length > 15
                                      }"
                                    >
                                      {{ childs.label }}
                                    </div>
                                  </template>
                                </el-table-column>
                              </template>
                              <template slot-scope="scope">
                                <template
                                  v-if="
                                    scope.row[child.scoreMaxMin] && status == 1
                                  "
                                >
                                  <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="
                                      scope.row[child.scoreMaxMin] == '1'
                                        ? '最高分'
                                        : '最低分'
                                    "
                                    placement="bottom"
                                  >
                                    <span class="remarkTip">{{
                                      scope.row[child.prop]
                                    }}</span>
                                  </el-tooltip>
                                </template>
                                <template v-else>
                                  <span>{{ scope.row[child.prop] }}</span>
                                </template>
                              </template>
                            </el-table-column>
                          </template>
                          <template slot-scope="scope">
                            <span v-if="item.money">{{
                              scope.row[item.prop]
                                ? new BigNumber(scope.row[item.prop]).toFormat(
                                    2
                                  )
                                : scope.row[item.prop]
                            }}</span>
                            <span v-else>{{ scope.row[item.prop] }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
              </el-tabs>
            </template>
            <template v-else>
              <div v-for="(listItem, listIndex) in listData" :key="listIndex">
                <el-tabs value="1" class="summaryTab summaryTabTwo">
                  <el-tab-pane label="汇总表" name="1">
                    <!-- <div class="ccui-tab-iframe">
                      <div class="ccui-tab-wrapper">
                        <el-button type="table-top" size="mini">
                          汇总表
                        </el-button>
                      </div>
                    </div> -->
                    <el-table :data="listItem.summaryTableData" border>
                      <el-table-column
                        v-for="(item, index) in listItem.summaryColumns"
                        :key="index"
                        :min-width="item.width"
                        :show-overflow-tooltip="true"
                        :header-align="item.money ? 'center' : ''"
                        v-bind="item"
                      >
                        <template
                          v-if="item.labelChild && item.labelChild.length > 0"
                        >
                          <el-table-column
                            v-for="(child, indexch) in item.labelChild"
                            :key="indexch"
                            align="center"
                            v-bind="child"
                          >
                            <template slot="header">
                              <div
                                :title="child.label"
                                class="el-tooltip tooltip-header"
                                :class="{
                                  'tooltip-header-flow': child.label.length > 15
                                }"
                              >
                                {{ child.label }}
                              </div>
                            </template>
                            <template
                              v-if="
                                child.labelChild && child.labelChild.length > 0
                              "
                            >
                              <el-table-column
                                v-for="(childs, indexch) in child.labelChild"
                                :key="indexch"
                                align="center"
                                width="180"
                                :prop="childs.prop"
                              >
                                <template slot="header">
                                  <div
                                    :title="childs.label"
                                    class="el-tooltip tooltip-header"
                                    style="margin:10px 0;line-height: 20px"
                                    :class="{
                                      'tooltip-header-flow':
                                        childs.label.length > 15
                                    }"
                                  >
                                    {{ childs.label }}
                                  </div>
                                </template>
                              </el-table-column>
                            </template>
                          </el-table-column>
                        </template>
                        <template slot-scope="scope">
                          <span v-if="item.money && item.type !== 'AIbtn'">{{
                            scope.row[item.prop] || scope.row[item.prop] === 0
                              ? new BigNumber(scope.row[item.prop]).toFormat(2)
                              : ""
                          }}</span>
                          <el-button
                            v-else-if="item.type == 'AIbtn'"
                            size="mini"
                            type="text"
                            @click="toAI(scope.row)"
                            >{{
                              scope.row[item.prop]
                                ? new BigNumber(scope.row[item.prop]).toFormat(
                                    2
                                  )
                                : ""
                            }}</el-button
                          >
                          <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="打分表" name="2">
                    <!-- <div class="ccui-tab-iframe">
                      <div class="ccui-tab-wrapper">
                        <el-button type="table-top" size="mini">
                          打分表
                        </el-button>
                      </div>
                    </div> -->
                    <template
                      v-if="isCheckedHighAndLow && type == 0 && status == 1"
                    >
                      <div class="remarkTip">
                        备注：红色分值为去掉的最高分或最低分
                      </div>
                    </template>
                    <el-table
                      :data="listItem.data"
                      border
                      max-height="460"
                      :span-method="spanMethod"
                    >
                      <el-table-column
                        v-for="(item, index) in listItem.columns"
                        :key="index"
                        :min-width="item.width"
                        :header-align="item.money ? 'center' : ''"
                        :show-overflow-tooltip="true"
                        v-bind="item"
                      >
                        <template
                          v-if="item.labelChild && item.labelChild.length > 0"
                        >
                          <el-table-column
                            v-for="(child, indexch) in item.labelChild"
                            :key="indexch"
                            align="center"
                            v-bind="child"
                          >
                            <template slot="header">
                              <div
                                :title="child.label"
                                class="el-tooltip tooltip-header"
                                :class="{
                                  'tooltip-header-flow': child.label.length > 15
                                }"
                              >
                                {{ child.label }}
                              </div>
                            </template>
                            <template
                              v-if="
                                child.labelChild && child.labelChild.length > 0
                              "
                            >
                              <el-table-column
                                v-for="(childs, indexch) in child.labelChild"
                                :key="indexch"
                                align="center"
                                width="180"
                                :prop="childs.prop"
                              >
                                <template slot="header">
                                  <div
                                    :title="childs.label"
                                    class="el-tooltip tooltip-header"
                                    style="margin:10px 0px;line-height: 20px"
                                    :class="{
                                      'tooltip-header-flow':
                                        childs.label.length > 15
                                    }"
                                  >
                                    {{ childs.label }}
                                  </div>
                                </template>
                              </el-table-column>
                            </template>
                            <template slot-scope="scope">
                              <template
                                v-if="
                                  scope.row[child.scoreMaxMin] && status == 1
                                "
                              >
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  :content="
                                    scope.row[child.scoreMaxMin] == '1'
                                      ? '最高分'
                                      : '最低分'
                                  "
                                  placement="bottom"
                                >
                                  <span class="remarkTip">{{
                                    scope.row[child.prop]
                                  }}</span>
                                </el-tooltip>
                              </template>
                              <template v-else>
                                <span>{{ scope.row[child.prop] }}</span>
                              </template>
                            </template>
                          </el-table-column>
                        </template>
                        <template slot-scope="scope">
                          <span v-if="item.money && item.type !== 'AIbtn'">{{
                            scope.row[item.prop]
                              ? new BigNumber(scope.row[item.prop]).toFormat(2)
                              : scope.row[item.prop]
                          }}</span>
                          <el-button
                            v-else-if="item.type == 'AIbtn'"
                            size="mini"
                            type="text"
                            @click="toAI(scope.row)"
                            >{{
                              scope.row[item.prop]
                                ? new BigNumber(scope.row[item.prop]).toFormat(
                                    2
                                  )
                                : ""
                            }}</el-button
                          >
                          <span v-else>{{ scope.row[item.prop] }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <template v-if="operateShow">
      <div class="operate">
        <template v-if="billStatus == 0">
          <el-button
            type="text"
            icon="icon-ccui-return"
            v-preventReClick
            @click="dealExpertSupScoreCancel"
            >撤销评分</el-button
          >
          <template
            v-if="listData[parseInt(active)].summaryTableData.length === 0"
          >
            <el-button
              type="text"
              icon="icon-ccui-data"
              v-preventReClick
              @click="operateSummary"
              >汇总</el-button
            >
          </template>
          <template
            v-if="listData[parseInt(active)].summaryTableData.length > 0"
          >
            <el-button
              type="text"
              icon="el-icon-refresh-right"
              v-preventReClick
              @click="operateSummary"
              >重新汇总</el-button
            >
          </template>
          <template v-if="submitFlag && billStatus != '1'">
            <el-button
              type="text"
              icon="icon-ccui-agree"
              v-preventReClick
              @click="dealSumScoreSubmit"
              >提交</el-button
            >
          </template>
        </template>
        <el-button type="text" icon="icon-ccui-sharing-o" @click="refresh"
          >刷新</el-button
        >
      </div>
    </template>
    <el-dialog
      :visible.sync="dialogVisible"
      title="供应商投标详细信息"
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails></supplierBidDetails>
      <div slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/sourcingFlow/views/supplierBidDetails.vue";
import { Loading } from "ccui";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  listPurchaseSchemePackageApi,
  qrySumScoreApi,
  qrySumScoreExpertScoreListApi,
  dealExpertSupScoreCancelApi,
  dealSumScoreSubmitApi,
  qryNotSubmitScoreExpertListApi,
  qryBidEvaProcessStatusApi,
  qryScoreListApi,
  bidSupPersonnelRelationWarning
} from "@/app/sourcingFlow/api/expertEvaluation.js";

export default {
  name: "summaryingOrComplete", // 汇总中/汇总完成
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  inject: ["reload"],
  props: {
    type: {
      type: Number, // 0: 技术评分汇总 1：商务技术评分汇总
      default: 0
    },
    status: {
      type: Number, // 0: 汇总中 1：汇总完成
      default: 0
    }
  },
  data() {
    return {
      breadcrumbData: {
        titname: this.type == 0 ? "技术评分汇总" : "商务技术评分汇总",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      billStatus: "0",
      labelType: this.billStatus == 0 ? "InSummary" : "SummaryComplete",
      dialogVisible: false,
      listData: [],
      // summaryTableData: [],
      active: "0",
      active2: "1",
      summaryColumns: [
        {
          prop: "id",
          label: "序号",
          width: 55
        },
        {
          prop: "supName",
          label: "供应商",
          width: 200
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术",
          labelChild: [],
          align: "center"
        },
        {
          prop: this.type == 1 ? "sumScore" : "techSumScore",
          label: "汇总得分",
          width: 110,
          align: "center",
          money: true
        }
        // {
        //   prop: "aiSumScore",
        //   label: "AI打分汇总",
        //   width: 110,
        //   type: "AIbtn",
        //   money: true
        // }
        // {
        //   prop: "lostFlagStr",
        //   label: "是否淘汰",
        //   width: 110
        // },
        // {
        //   prop: "lostReason",
        //   label: "淘汰理由",
        //   width: 250
        // }
      ],
      columns: [
        {
          prop: "id",
          label: "序号",
          width: 55,
          fixed: true
        },
        {
          prop: "expertName",
          label: "评分专家",
          width: 170,
          fixed: true
        },
        {
          prop: "supName",
          label: "供应商",
          width: 200,
          fixed: true
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 180,
          align: "right",
          money: true
        },
        // {
        //   prop: "sscScoreItemBOS",
        //   label: "技术",
        //   labelChild: [],
        //   align: "center"
        // },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 110,
          align: "center",
          money: true
        },
        // {
        //   prop: "aiSumScore",
        //   label: "AI打分汇总",
        //   width: 110,
        //   type: "AIbtn",
        //   money: true
        // },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 300
        },
        {
          prop: "updateTime",
          label: "评分提交时间",
          width: 170
        }
      ],
      evaForm: JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
        .evaForm, // 1：技术商务组合评分 2：技术商务分开评分
      labelShow: false,
      operateShow: false,
      subPackageFlag: false, // 是否分包件 false:不分包
      submitFlag: false, // 提交按钮是否展示，任一包件有汇总数据都可展示
      isCheckedHighAndLow: false, // 是否选中了去除技术评分的最高最低
      purchaseType: "",
      BigNumber: BigNumber,
      relationWarningList: []
    };
  },
  watch: {
    active: function(newValue, oldValue) {
      this.active2 = "1";
    }
  },
  created() {
    this.$route.query.active && (this.active = this.$route.query.active);
    if (this.type == "0") {
      this.summaryColumns.push(
        {
          prop: "lostFlagStr",
          label: "是否淘汰",
          width: 110
        },
        {
          prop: "lostReason",
          label: "淘汰理由",
          width: 250
        }
      );
    }
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      this.summaryColumns.splice(5, 1);
      this.columns.splice(6, 1);
    }

    this.getData();
    this.getSupPersonnelRelationWarning();
  },
  methods: {
    // 刷新
    refresh() {
      this.getData();
      this.reload();
    },
    getSupPersonnelRelationWarning() {
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        step: "6",
        languageFlag: ""
      };
      bidSupPersonnelRelationWarning(param).then(res => {
        if (res.data.code == "0") {
          this.relationWarningList = res.data.data.compareResult;
        }
      });
    },
    getData() {
      qryScoreListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        if (res.data.data) {
          this.isCheckedHighAndLow = res.data.data.sumForm === "102";
        }
      });
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        this.$set(this, "labelShow", false);
        this.$set(
          this,
          "billStatus",
          res.data.data.billStatus == "1" ? "0" : "1"
        );
        this.$set(
          this,
          "labelType",
          res.data.data.billStatus === "1" ? "InSummary" : "SummaryComplete"
        ); // 0:制定中 1：制定完成
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        // this.active = "0";
        this.active2 = "1";
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.$set(this, "labelShow", true);
      });
      listPurchaseSchemePackageApi({
        pageNo: 1,
        pageSize: 100,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
        let arr = [];
        if (this.subPackageFlag) {
          res.data.data.purchaseSchemePackageList.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              arr.push(this.getSumAndExpertScore(item.packId, item.packName));
            }
          });
        } else {
          arr.push(this.getSumAndExpertScore("", ""));
        }
        Promise.all(arr).then(res1 => {
          if (res1 && res1.length > 0) {
            // 通过包件id进行排序
            res1.sort(function(a, b) {
              if (a.joinExpertId > b.joinExpertId) {
                return 1;
              } else if (a.joinExpertId < b.joinExpertId) {
                return -1;
              } else {
                return 0;
              }
            });
            res1.forEach((item, index) => {
              item.summaryColumns = JSON.parse(
                JSON.stringify(this.summaryColumns)
              ); // 汇总表
              item.columns = JSON.parse(JSON.stringify(this.columns)); // 打分表
              if (this.type == 1) {
                // 汇总表
                if (this.purchaseType == "50" || this.purchaseType == "53") {
                  item.summaryColumns.splice(6, 0, {
                    prop: "sscCommonScoreItemBOS",
                    label: "商务",
                    labelChild: [],
                    align: "center"
                  });
                } else {
                  item.summaryColumns.splice(7, 0, {
                    prop: "sscCommonScoreItemBOS",
                    label: "商务",
                    labelChild: [],
                    align: "center"
                  });
                }
              }
              // 打分表列操作
              if (this.type == 0) {
                // 技术评分汇总
                item.columns.splice(7, 0, {
                  prop: "sscScoreItemBOS",
                  label: "技术",
                  labelChild: [],
                  align: "center"
                });
              }
              if (this.type == 1) {
                // 技术商务评分汇总
                if (this.evaForm == "1") {
                  // 组合评分
                  item.columns.splice(7, 0, {
                    prop: "sscScoreItemBOS",
                    label: "技术",
                    labelChild: [],
                    align: "center"
                  });
                  item.columns.splice(8, 0, {
                    prop: "sscCommonScoreItemBOS",
                    label: "商务",
                    labelChild: [],
                    align: "center"
                  });
                }
                if (this.evaForm == "2") {
                  if (this.purchaseType == "50" || this.purchaseType == "53") {
                    // 分开评分
                    item.columns.splice(6, 0, {
                      prop: "sscCommonScoreItemBOS",
                      label: "商务",
                      labelChild: [],
                      align: "center"
                    });
                  } else {
                    // 分开评分
                    item.columns.splice(7, 0, {
                      prop: "sscCommonScoreItemBOS",
                      label: "商务",
                      labelChild: [],
                      align: "center"
                    });
                  }
                }
              }

              // 打分表逻辑开始
              let skillChild = []; // 技术评分的表头
              let commonChild = []; // 商务评分的表头
              let devspan = 0; // 之前行的数
              let data = []; // 数据
              let id = 0; // 序号
              item.expertList.forEach((aItem, aIndex) => {
                id++;
                if (aIndex > 0) {
                  devspan +=
                    item.expertList[aIndex - 1].sscSupQuoteScoreBOS.length;
                  // item.expertList[aIndex - 1].sscSupQuoteScoreBOS.forEach(a => {
                  //   devspan += a.sscSupScoreBOS.length;
                  // });
                }
                aItem.sscSupQuoteScoreBOS.forEach((bItem, bIndex) => {
                  bItem.supScore = bItem.supScore
                    ? new BigNumber(bItem.supScore).toFormat(2)
                    : bItem.supScore;
                  let columnCount = 10; // 总共有多少列，用于计算最后一列的合并
                  bItem.sscSupScoreBOS.forEach(b => {
                    columnCount += b.sscSupScoreItemBOS.length;
                  });
                  let obj = {
                    id: id,
                    joinExpertId: aItem.joinExpertId,
                    expertName: aItem.expertName,
                    supJoinId: bItem.supJoinId,
                    supQuoteId: bItem.supQuoteId,
                    supCode: bItem.supCode,
                    supName: bItem.supName,
                    taskId: bItem.taskId,
                    priceAmount: bItem.priceAmount,
                    supScore: bItem.supScore
                      ? new BigNumber(bItem.supScore).toFormat(2)
                      : bItem.supScore,
                    scoreDesc: bItem.scoreDesc,
                    aiSumScore: bItem.aiSumScore,
                    updateTime: bItem.updateTime,
                    devspan: devspan,
                    rowspan: aItem.sscSupQuoteScoreBOS.length,
                    columnCount: columnCount,
                    industryTypeName: bItem.industryTypeName,
                    companyTypeName: bItem.companyTypeName,
                    supCategoryName: bItem.supCategoryName,
                    supLevelName: bItem.supLevelName,
                    supTypeNewName: bItem.supTypeNewName
                  };
                  bItem.sscSupScoreBOS.forEach((cItem, cIndex) => {
                    cItem.sscSupScoreItemBOS.forEach((dItem, dIndex) => {
                      obj.scoreRule = dItem.scoreRule;
                      let props =
                        "supScore-" + cItem.scoreItem + "-" + dItem.scoreItemId;
                      obj[props] = dItem.supScore
                        ? new BigNumber(dItem.supScore).toFormat(2)
                        : dItem.supScore;
                      if (this.type == 0) {
                        if (cItem.scoreItem === "0") {
                          let scoreMaxMin =
                            "scoreMaxMin-" +
                            +cItem.scoreItem +
                            "-" +
                            dItem.scoreItemId;
                          obj[scoreMaxMin] = dItem.scoreMaxMin;
                          if (
                            skillChild.filter(item => {
                              return (
                                item.prop ==
                                "supScore-" +
                                  cItem.scoreItem +
                                  "-" +
                                  dItem.scoreItemId
                              );
                            }).length == 0
                          ) {
                            skillChild.push({
                              prop: props,
                              label: dItem.scoreRule,
                              scoreMaxMin: scoreMaxMin,
                              width: 280,
                              labelChild: [
                                {
                                  prop: props,
                                  label: "细则权重:" + dItem.scoreWeight,
                                  width: 280,
                                  money: true
                                }
                              ]
                            });
                          }
                        }
                      }
                      if (this.type == 1) {
                        if (this.evaForm == "1") {
                          // 组合评分
                          if (cItem.scoreItem === "0") {
                            let scoreMaxMin =
                              "scoreMaxMin-" +
                              +cItem.scoreItem +
                              "-" +
                              dItem.scoreItemId;
                            obj[scoreMaxMin] = dItem.scoreMaxMin;
                            if (
                              skillChild.filter(item => {
                                return (
                                  item.prop ==
                                  "supScore-" +
                                    cItem.scoreItem +
                                    "-" +
                                    dItem.scoreItemId
                                );
                              }).length == 0
                            ) {
                              skillChild.push({
                                prop: props,
                                label: dItem.scoreRule,
                                scoreMaxMin: scoreMaxMin,
                                width: 280,
                                labelChild: [
                                  {
                                    prop: props,
                                    label: "细则权重:" + dItem.scoreWeight,
                                    width: 280,
                                    money: true
                                  }
                                ]
                              });
                            }
                          }
                          if (cItem.scoreItem === "1") {
                            if (
                              commonChild.filter(item => {
                                return (
                                  item.prop ==
                                  "supScore-" +
                                    cItem.scoreItem +
                                    "-" +
                                    dItem.scoreItemId
                                );
                              }).length == 0
                            ) {
                              commonChild.push({
                                prop: props,
                                label: dItem.scoreRule,
                                width: 280,
                                labelChild: [
                                  {
                                    prop: props,
                                    label: "细则权重:" + dItem.scoreWeight,
                                    width: 280,
                                    money: true
                                  }
                                ]
                              });
                            }
                          }
                        }
                        if (this.evaForm == "2") {
                          // 分开评分
                          if (cItem.scoreItem === "1") {
                            if (
                              commonChild.filter(item => {
                                return (
                                  item.prop ==
                                  "supScore-" +
                                    cItem.scoreItem +
                                    "-" +
                                    dItem.scoreItemId
                                );
                              }).length == 0
                            ) {
                              commonChild.push({
                                prop: props,
                                label: dItem.scoreRule,
                                width: 280,
                                labelChild: [
                                  {
                                    prop: props,
                                    label: "细则权重:" + dItem.scoreWeight,
                                    width: 280,
                                    money: true
                                  }
                                ]
                              });
                            }
                          }
                        }
                      }
                    });
                  });
                  data.push(obj);
                });
              });

              if (skillChild.length + commonChild.length < 3) {
                if (this.type == 1) {
                  // delete item.columns[5].width;
                } else {
                  // delete item.columns[6].width;
                }
              }
              if (this.type == 0) {
                // 技术评分汇总
                item.columns[7].labelChild = skillChild;
              }
              if (this.type == 1) {
                // 技术商务评分汇总
                if (this.evaForm == "1") {
                  // 组合评分
                  item.columns[7].labelChild = skillChild;
                  item.columns[8].labelChild = commonChild;
                }
                // 分开评分
                if (this.evaForm == "2") {
                  if (this.purchaseType == "50" || this.purchaseType == "53") {
                    item.columns[6].labelChild = commonChild;
                  } else {
                    item.columns[7].labelChild = commonChild;
                  }
                }
              }
              item.data = data;
              // 汇总表逻辑开始
              let sumSkillChild = []; // 汇总表技术评分表头
              let sumCommonChild = []; // 打分表技术评分表头
              if (item.summaryTableData && item.summaryTableData.length > 0) {
                item.summaryTableData.forEach((sumItem, sumIndex) => {
                  sumItem.supScore = sumItem.supScore
                    ? new BigNumber(sumItem.supScore).toFormat(2)
                    : sumItem.supScore;
                  sumItem.techSumScore = sumItem.techSumScore
                    ? new BigNumber(sumItem.techSumScore).toFormat(2)
                    : sumItem.techSumScore;
                  sumItem.id = sumIndex + 1;
                  sumItem.lostFlagStr =
                    sumItem.lostFlag == "1" ? "淘汰" : "不淘汰";
                  sumItem.sscSupScoreSumItemBOS.forEach(
                    (scoreSumItem, scoreSumIndex) => {
                      let props =
                        "supScore-" +
                        scoreSumItem.scoreItem +
                        "-" +
                        scoreSumItem.scoreItemId;
                      sumItem[props] = scoreSumItem.supScore
                        ? new BigNumber(scoreSumItem.supScore).toFormat(2)
                        : scoreSumItem.supScore;
                      if (this.type == 1) {
                        // 商务技术评分汇总
                        if (scoreSumItem.scoreItem === "1") {
                          if (
                            sumCommonChild.filter(item => {
                              return (
                                item.prop ==
                                "supScore-" +
                                  scoreSumItem.scoreItem +
                                  "-" +
                                  scoreSumItem.scoreItemId
                              );
                            }).length == 0
                          ) {
                            console.log(scoreSumItem);
                            sumCommonChild.push({
                              prop: props,
                              label: scoreSumItem.scoreRule,
                              width: 280,
                              labelChild: [
                                {
                                  prop: props,
                                  label: "细则权重:" + scoreSumItem.scoreWeight,
                                  width: 280,
                                  money: true
                                }
                              ]
                            });
                          }
                        }
                      }
                      if (scoreSumItem.scoreItem === "0") {
                        if (
                          sumSkillChild.filter(item => {
                            return (
                              item.prop ==
                              "supScore-" +
                                scoreSumItem.scoreItem +
                                "-" +
                                scoreSumItem.scoreItemId
                            );
                          }).length == 0
                        ) {
                          console.log(22);
                          sumSkillChild.push({
                            prop: props,
                            label: scoreSumItem.scoreRule,
                            width: 280,
                            labelChild: [
                              {
                                prop: props,
                                label: "细则权重:" + scoreSumItem.scoreWeight,
                                width: 280,
                                money: true
                              }
                            ]
                          });
                        }
                      }
                    }
                  );
                });
                if (this.purchaseType == "50" || this.purchaseType == "53") {
                  if (sumSkillChild.length + sumCommonChild.length < 3) {
                    if (this.type == 1) {
                      delete item.summaryColumns[7].width;
                    } else {
                      delete item.summaryColumns[8].width;
                    }
                  }
                  item.summaryColumns[5].labelChild = sumSkillChild;
                  if (this.type == 1) {
                    item.summaryColumns[6].labelChild = sumCommonChild;
                  }
                } else {
                  if (sumSkillChild.length + sumCommonChild.length < 3) {
                    if (this.type == 1) {
                      delete item.summaryColumns[8].width;
                    } else {
                      delete item.summaryColumns[9].width;
                    }
                  }
                  item.summaryColumns[6].labelChild = sumSkillChild;
                  if (this.type == 1) {
                    item.summaryColumns[7].labelChild = sumCommonChild;
                  }
                }
              }
              if (
                res1.length &&
                res1[0].data &&
                res1[0].data.length &&
                !res1[0].data[0].taskId
              ) {
                item.columns = item.columns.filter(
                  item => item.prop != "aiSumScore"
                );
                item.summaryColumns = item.summaryColumns.filter(
                  item => item.prop != "aiSumScore"
                );
              }
            });
            this.submitFlag = res1.some(
              item => item.summaryTableData.length > 0
            );
            this.listData = res1;
          }
          this.operateShow = true;
        });
      });
    },
    toAI(row) {
      let baseUrl = "http://47.108.13.132:8102";
      if (window.location.host.indexOf("local") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("test01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("uat01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else {
        baseUrl = "https://aimarket.iccec.cn";
      }
      window.open(
        baseUrl +
          "/front/supplyChain/summaryResults?taskId=" +
          row.taskId +
          "&editable=false&step=1&token=" +
          sessionStorage.getItem("AItoken"),
        "_blank"
      );
    },
    getSumAndExpertScore(packId, packName) {
      return new Promise((resolve, reject) => {
        // 汇总表
        qrySumScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId,
          isShowloading: true,
          isShowPageLoading: true,
          sumScoreType: this.type == 0 ? "0" : "2"
        }).then(res => {
          let obj = {
            summaryTableData: [],
            packId: packId,
            packName: packName,
            expertList: []
          };
          res.data.data.forEach(item => {
            item.techSumScore = item.sumScore;
            item.supScore = item.supScore ? item.sumScore : item.supScore;
          });
          obj.summaryTableData = res.data.data;
          let param = {
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            packId: packId,
            isShowloading: true,
            packName: packName
          };
          if (this.type == 0) {
            param.scoreItem = "0";
          } else {
            if (this.evaForm == "2") {
              param.scoreItem = "1";
            }
          }
          qrySumScoreExpertScoreListApi(param).then(res1 => {
            obj.expertList = res1.data.data;
            resolve(obj);
          });
        });
      });
    },
    // 打分表表格合并行列
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    viewBidFile(row) {
      this.dialogVisible = true;
    },
    operateSummary() {
      let loadingObj = Loading.service({
        lock: true,
        text: "汇总评分可能需要3-5分钟，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });

      // 汇总的时候有的专家可能还没有提交评分 如果一个都没有提交是不允许汇总的
      qryNotSubmitScoreExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        packId: this.listData[this.active].packId,
        isShowLoading: true,
        scoreItem: this.type == 0 ? "0" : this.evaForm == "1" ? "" : "1"
      })
        .then(res => {
          loadingObj.close();
          if (res.data.data.expertSubmitFlag != "1") {
            this.$router.push({
              name: "operateSkillOrCommonSummary",
              query: {
                type: this.type,
                packId: this.listData[Number(this.active)].packId,
                a: this.$router.history.current.query.a,
                menuKey: this.$router.history.current.query.menuKey,
                active: this.active
              }
            });
          } else {
            this.$message({
              message: "没有专家提交评分，不能进行汇总，请先进行专家评分的提交",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        })
        .catch(() => {
          loadingObj.close();
        });
    },
    // 撤销评分
    dealExpertSupScoreCancel() {
      this.$confirm(
        "您确定要撤销专家评分吗？撤销后，需专家重新提交评分？",
        "撤销评分",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "ccui-message-box-custom"
        }
      )
        .then(() => {
          dealExpertSupScoreCancelApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            scoreType: this.type == 0 ? 0 : this.evaForm == "1" ? 2 : 1
          }).then(res => {
            if (res.data.code == "0") {
              // this.$router.push({
              //   name:
              //     this.type == 1
              //       ? "summaryBusinessSkillsScores"
              //       : "technicalScoreSummary",
              //   query: {
              //     a: this.$router.history.current.query.a,
              //     menuKey: this.$router.history.current.query.menuKey
              //   }
              // });
              this.$message({
                message: "撤销评分成功",
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              this.refresh();
            }
          });
        })
        .catch(() => {});
    },
    // 提交
    dealSumScoreSubmit() {
      console.log(this.listData);
      // 如果没有汇总完成不允许进行提交
      let summaryFlag = this.listData.some(
        item => item.summaryTableData.length === 0
      );
      if (summaryFlag) {
        this.$message({
          message:
            "您还有汇总未完成的包件，请您对每个包件中的供应商评分汇总完毕后，再提交评分汇总结果，谢谢您的配合！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return;
      } else {
        // 汇总的时候有的专家可能还没有提交评分 如果存在没有评分是不允许提交的
        qryNotSubmitScoreExpertListApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          scoreItem: this.type == 0 ? "0" : "2"
        }).then(res => {
          if (res.data.data.expertSubmitFlag != "3") {
            this.$confirm(
              `评标专家：“${res.data.data.expertNames}”还未提交评分表，您是否确定要提交汇总表？汇总表提交后，此信息将不允许重新汇总。`,
              "提交汇总",
              {
                distinguishCancelAndClose: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                customClass: "ccui-message-box-custom"
              }
            )
              .then(() => {
                dealSumScoreSubmitApi({
                  schemeId: JSON.parse(
                    sessionStorage.getItem("expertSourceData")
                  ).schemeId,
                  sumScoreType: this.type == 0 ? 0 : 2
                }).then(res => {
                  if (res.data.code == "0") {
                    this.refresh();
                    this.$message({
                      message: "提交成功",
                      type: "success",
                      duration: 3000,
                      showClose: true,
                      ccuiCustom: true
                    });
                  }
                });
              })
              .catch(() => {});
          } else {
            dealSumScoreSubmitApi({
              schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                .schemeId,
              sumScoreType: this.type == 0 ? 0 : 2
            }).then(res => {
              if (res.data.code == "0") {
                this.$message({
                  message: "提交成功",
                  type: "success",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
                this.refresh();
              }
            });
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: red;
  padding: 20px 0 0 20px;
}
.tooltip-header {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 10px 0;
  line-height: 20px;
}
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    padding: 0;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}

.remarkTip {
  color: #ff142f;
  margin-top: 19px;
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
</style>
